/* Copy/devtools deterrents. Config comes from window.mmSecCfg, printed inline by snippets/security-advanced.liquid. Moved out of inline 2026-09-29. */
(function () {
  var c = window.mmSecCfg;
  if (!c) return;

  // ── Trusted-context bypass ───────────────────────────────────────
  // The owner/developer should never trip these deterrents. Stand down
  // entirely in the theme editor, on a Shopify preview link, on a local
  // `shopify theme dev` host, or on any browser the owner has whitelisted
  // by visiting once with ?mm_dev=1 (clear it again with ?mm_dev=0).
  // Also stand down for automation (navigator.webdriver): heatmap/SEO
  // snapshot crawlers (e.g. Propel Replays) must capture the page
  // untouched — deterrents are for humans, and they can't stop a bot
  // from reading HTML anyway. The anti-clone domain lock is separate
  // and unaffected by this.
  var trusted = false;
  try {
    var qs = location.search || '';
    trusted =
      (window.Shopify && window.Shopify.designMode === true) ||
      navigator.webdriver === true ||
      location.hostname === 'localhost' ||
      location.hostname === '127.0.0.1' ||
      /[?&]preview_theme_id=/.test(qs);
    try {
      if (/[?&]mm_dev=0(?:&|$)/.test(qs)) localStorage.removeItem('mm_dev');
      else if (/[?&]mm_dev=1(?:&|$)/.test(qs)) localStorage.setItem('mm_dev', '1');
      if (localStorage.getItem('mm_dev') === '1') trusted = true;
    } catch (e2) {}
  } catch (e) {}
  if (trusted) return;

  var isField = function (el) {
    if (!el || !el.tagName) return false;
    var t = el.tagName;
    return t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT' || el.isContentEditable;
  };
  if (c.rc) document.addEventListener('contextmenu', function (e) {
    if (!isField(e.target) && e.target.tagName !== 'A') e.preventDefault();
  });
  if (c.id) document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  });
  if (c.cp) {
    document.addEventListener('copy', function (e) { if (!isField(e.target)) e.preventDefault(); });
    document.addEventListener('cut',  function (e) { if (!isField(e.target)) e.preventDefault(); });
  }
  if (c.ps) {
    document.addEventListener('paste', function (e) { if (!isField(e.target)) e.preventDefault(); });
  }
  if (c.dk || c.pr || c.sv) {
    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toLowerCase();
      if (c.dk) {
        if (k === 'f12') { e.preventDefault(); return; }
        if ((e.ctrlKey || e.metaKey) && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) { e.preventDefault(); return; }
        if ((e.ctrlKey || e.metaKey) && k === 'u') { e.preventDefault(); return; }
      }
      if (c.sv && (e.ctrlKey || e.metaKey)) {
        if (k === 's') { e.preventDefault(); return; }
        if (k === 'a' && !isField(e.target)) { e.preventDefault(); return; }
      }
      if (c.pr && (e.ctrlKey || e.metaKey) && k === 'p') { e.preventDefault(); }
    });
  }
  var reacted = false;
  var react = function () {
    // Blur is reversible: the detector clears it the moment the signal
    // goes away, so a transient or false hit heals itself instead of
    // stranding the visitor on a permanently blurred page.
    if (c.da === 'blur') {
      document.documentElement.style.filter = 'blur(12px)';
      return;
    }
    if (reacted) return; reacted = true;
    switch (c.da) {
      case 'blank':
        // The closing body tag MUST stay backslash-escaped: apps/proxies that
        // inject "before the closing body tag" string-match the FIRST literal
        // occurrence in the HTML — an unescaped one here splits this script
        // and dumps its tail as visible page text (live incident 2026-08-06).
        document.documentElement.innerHTML = '<body style="font:16px system-ui;padding:2rem">' + (c.dm || '') + '<\/body>';
        break;
      case 'redirect':
        if (c.dr) location.replace(c.dr);
        break;
      default:
        var w = document.createElement('div');
        w.setAttribute('role', 'alert');
        w.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.92);color:#fff;font:16px/1.5 system-ui,sans-serif;display:flex;align-items:center;justify-content:center;padding:2rem;text-align:center';
        w.textContent = c.dm || 'Developer tools are not allowed.';
        document.body.appendChild(w);
    }
  };
  var unreact = function () {
    if (c.da === 'blur') document.documentElement.style.filter = '';
  };
  if (c.dd) {
    // Detect docked DevTools by the window/viewport gap, but defensively:
    //   • desktop pointers only (the mobile address-bar collapse fakes it);
    //   • baseline the gap at load and react only to a further increase,
    //     so a page opened at high browser zoom isn't read as DevTools;
    //   • stand down while the user is zoomed away from that baseline;
    //   • require two consecutive samples to debounce transient reflows.
    // The old every-4s `debugger;` trap was removed: it froze the page for
    // anyone with DevTools open and stuttered real users on slow devices.
    var coarse = (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) || ('ontouchstart' in window);
    if (!coarse) {
      var TH = 160;
      // Baseline lazily, from the first VALID sample — never at parse
      // time. During first load restored/background tabs can report
      // outer sizes of 0 (or transient values), and a baseline poisoned
      // that way reads as "DevTools open" on every later sample,
      // blurring the page permanently for a normal visitor.
      var baseGapW = null;
      var baseGapH = null;
      var baseDpr = window.devicePixelRatio || 1;
      var strikes = 0;
      setInterval(function () {
        if (document.hidden) return;
        if (window.outerWidth <= 0 || window.outerHeight <= 0) return;
        var dpr = window.devicePixelRatio || 1;
        // Zoom changed: gaps aren't comparable across zoom levels, so
        // drop the baseline and re-capture at the new level.
        if (Math.abs(dpr - baseDpr) > 0.02) { baseDpr = dpr; baseGapW = null; baseGapH = null; strikes = 0; unreact(); return; }
        var gapW = window.outerWidth - window.innerWidth;
        var gapH = window.outerHeight - window.innerHeight;
        // Ratchet the baseline down to the smallest gap ever observed,
        // so a transiently inflated state at load self-heals instead of
        // counting as DevTools for the rest of the visit.
        if (baseGapW === null || gapW < baseGapW) baseGapW = gapW;
        if (baseGapH === null || gapH < baseGapH) baseGapH = gapH;
        var open = (gapW - baseGapW) > TH ||
                   (gapH - baseGapH) > TH;
        if (open) {
          strikes++;
          if (strikes >= 2) react();
        } else {
          strikes = 0;
          unreact();
        }
      }, 1000);
    }
  }
  if (c.ban) {
    try {
      console.log('%c' + c.bt, 'color:#fff;background:#b85454;font:700 28px/1.2 system-ui;padding:8px 14px;border-radius:4px');
      console.log('%c' + c.bm, 'font:14px/1.5 system-ui;color:#0E0E0C');
    } catch (e) {}
  }
})();
